import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { WsUserProfileService } from 'src/app/ws/wsUserProfile/ws-user-profile.service';
import { MAddressListRequest, MAddressRequest, MAddressResponseData, MOrderDetailRequest, MUserProfileRequest, MUserProfileResponseData } from 'src/app/pages/user/user.module';
import { lastValueFrom } from 'rxjs';
import { SharedPrefrences } from 'src/app/utils/utils.service';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { WsShopallService } from 'src/app/ws/wsShopAll/ws-shopall.service';
import { CommonBehaviorChangeService } from 'src/app/utils/common-behaviour-service';
import html2canvas from 'html2canvas';
import jspdf from 'jspdf';
import { SpinnerVisibilityService } from 'ng-http-loader';
import moment from 'moment';
import { LoginPopupComponent } from 'src/app/components/login-popup/login-popup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MAddUpdateCartModule, MAddUpdateCartModuleResponse } from 'src/app/pages/product-detail-updated/product-detail-updated.module';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent {
  [x: string]: any;
  @ViewChild('pdfTable', { static: false }) pdfTable!: ElementRef;
  id: any;
  mUserProfileReq: MUserProfileRequest = new MUserProfileRequest();
  mUserProfileData: MUserProfileResponseData = new MUserProfileResponseData();
  mAddressListReq: MAddressListRequest = new MAddressListRequest();
  mAddressListData: any
  mOrderReq: MOrderDetailRequest = new MOrderDetailRequest();
  mAddressReq: MAddressRequest = new MAddressRequest();
  mAddressResponseData?: MAddressResponseData;
  mOrderDetailListData: any;
  mWishlistData: any = [];
  addressFormgroup!: FormGroup;
  emailFormgroup!: FormGroup;
  viewForm: any = '';
  addressData: any;
  orderForm = false;
  mOrderDetail: any;
  mAddUpdateCartModuleResponse: any = new MAddUpdateCartModuleResponse()
  mAddUpdateCartModule: MAddUpdateCartModule = new MAddUpdateCartModule()
  userProfileForm!: FormGroup;
  profile_pic: any = null;
  genderList: any = []
  selectedGender: any = -1;
  skinDetailList: any;
  hairDetailList: any;
  makeupDetailList: any;
  makeupDetailsAvailable: any = false;
  skinJson: any = {
    skinType: [],
    skinConcern: {
      skinConcern1: [],
      skinConcern2: []
    }
  }
  hairJson: any = {
    skinType: [],
    skinConcern: {
      hairConcern1: [],
      hairConcern2: []
    }
  }
  makeUpJson: any = {};
  @Input() webView: any;
  defaultAddress: any;
  skinConcern1: any;
  hairConcern1: any;
  selectedGenderLabel: string = 'Select';
  isLoading: boolean = false
  status: any = false;
  profileData:any;
  constructor(private toast: ToastrService, private _formBuilder: FormBuilder, private spinner: SpinnerVisibilityService, private modalService: NgbModal, private _commonBehaviorChangeService: CommonBehaviorChangeService, private wsUserProfileService: WsUserProfileService, elRef: ElementRef, private router: Router, private wsShopAllService: WsShopallService) {
    this._commonBehaviorChangeService.currentrCartList.subscribe((cartList: any) => {
      this.mAddUpdateCartModuleResponse.data = cartList.data;
    })
    this._commonBehaviorChangeService.currentWishList.subscribe((wishList: any) => {
      this.mWishlistData = wishList;
    })


  }

  get f() {
    return this.emailFormgroup.controls;
  }

  initialLizeForm() {
    var EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.userProfileForm = this._formBuilder.group({
      first_name: [''],
      last_name: [''],
      age: [0],
      gender: [-1],
      alternet_phone_number: [null, [Validators.required, Validators.minLength(10)]],
      email: ["", [Validators.required, Validators.pattern(EMAIL_REGEX)]],
      profile_pic: []
    })

    this.emailFormgroup = this._formBuilder.group({
      email: new FormControl('', [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]),
    });
  
  }

  downloadAsPDF() {
    this.spinner.show()
    const doc = new jspdf("p", "mm", "a4");

    // Define options for html2canvas
    const options = {
      scale: 2 // Adjust the scale factor as needed for better quality
    };
    const element: any = document.getElementById('pdfTable');
    $('#pdfTable').removeAttr('hidden')
    // Convert HTML to canvas using html2canvas
    html2canvas(element, options).then(canvas => {
      // Get the width and height of the canvas
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      // Calculate the page width and height based on the aspect ratio
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = canvasHeight * (pageWidth / canvasWidth);

      // Add the canvas to the PDF document
      const imageData = canvas.toDataURL('image/png', 1);
      doc.addImage(imageData, 'PNG', 0, 0, pageWidth, pageHeight);

      // Save the PDF document
      doc.save('output.pdf');
      this.spinner.hide()
      // element.style.display = 'none'
      $('#pdfTable').attr('hidden', 'true')
    });
  }

  savedAddress(index: any) {
    $(".address-hide-content-" + index).slideToggle();
  }

  itemDeliveredProcess(mOrderData: any) {
    this.orderForm = true;
    this.mOrderDetail = mOrderData
  }

  orderDetail() {
    this.orderForm = false;
  }

  showDate(val: any) {
    return moment(val).format('MMM , DD YYYY');
  }

  orderProcess() {
    $(".process-arrow img").toggleClass("arrow-rotate");
    $(".order-process").toggleClass("process-show");
  }

  ngOnInit() {

    this.initialLizeForm()
    this.id = SharedPrefrences.getUserId();
    this.getGender()
    this.mUserProfileReq.id = this.id
    this.getUserPofile(this.mUserProfileReq)

    this.mAddressListReq.userId = this.id
    this.getAddressList(this.mAddressListReq)

    this.mOrderReq.take = 10;
    this.mOrderReq.skip = 0;
    this.mOrderReq.search = "odr.user_id = '" + this.id + "'";
    this.getOrderDetaiList(this.mOrderReq);

    this.getWishList(this.id);
    this.getAllCartProducts();


    if (localStorage.getItem('orderType') == 'order') {
      $('#order-tab').trigger('click')
      localStorage.setItem('orderType', '')
    }
  }

  backClick() {
    this.router.navigate(['/home-page/']);
  }


  /**
  * Date:- 13-06-2023
  * Method :- This method is used to Set Address Details In Edit Form
  */
  addUpdateAddress(val: any, address?: MAddressResponseData) {
    this.router.navigate(['/user-address/']);
  }

  /**
  * Date:- 13-06-2023
  * Method :- This method is used to Get User Profile Details
  * @param id :-  This param is used for request to Get Profile Details
  */
  async getUserPofile(id: MUserProfileRequest) {
    const userProfile = this.wsUserProfileService.getUserProfile(id)
    await lastValueFrom(userProfile).then(async response => {
      if (response && response.statusCode == 200) {
        this.mUserProfileData = response.data
        this.userProfileForm.patchValue({
          first_name: this.mUserProfileData && this.mUserProfileData.first_name ? this.mUserProfileData.first_name : '',
          last_name: this.mUserProfileData && this.mUserProfileData.last_name ? this.mUserProfileData.last_name : '',
          age: this.mUserProfileData && this.mUserProfileData.age ? this.mUserProfileData.age : '',
          gender: this.mUserProfileData && this.mUserProfileData.gender ? this.mUserProfileData.gender : '',
          alternet_phone_number: this.mUserProfileData && this.mUserProfileData.phone_number ? this.mUserProfileData.phone_number : '',
          email: this.mUserProfileData && this.mUserProfileData.email ? this.mUserProfileData.email : '',
        })
        this.profile_pic = this.mUserProfileData.profile_pic;
        this.selectedGender = this.mUserProfileData.gender;
        if(this.selectedGender == 0 || this.selectedGender == 1 || this.selectedGender == 2){
          this.selectGender(this.selectedGender)
        }
        else{
          this.selectedGenderLabel = 'Select';
        }
        this.skinJson = {
          skinType: this.mUserProfileData.skin_type ? JSON.parse(this.mUserProfileData.skin_type) : [],
          skinConcern: {
            skinConcern1: this.mUserProfileData.skin_Concern1 ? JSON.parse(this.mUserProfileData.skin_Concern1) : [],
            skinConcern2: this.mUserProfileData.skin_Concern2 ? JSON.parse(this.mUserProfileData.skin_Concern2) : []
          }
        }
        var sc = await this.skinJson.skinConcern.skinConcern1 && this.skinJson.skinConcern.skinConcern1.map((item: any) => {
          return item.id;
        });
        if (sc && sc.length > 0) {
          this.skinConcern1 = sc.join(',');
        }
        this.hairJson = JSON.parse(this.mUserProfileData.hair_json)
        if (!this.hairJson) {
          this.hairJson = {
            skinType: [],
            skinConcern: {
              hairConcern1: [],
              hairConcern2: []
            }
          }
          var hc = await this.hairJson.skinConcern.hairConcern1 && this.hairJson.skinConcern.hairConcern1.map((item: any) => {
            return item.id;
          });
          if (hc && hc.length > 0) {
            this.hairConcern1 = hc.join(',');
          }
        }
        this.makeUpJson = JSON.parse(this.mUserProfileData.makeup_json)

        setTimeout(() => {
          this.getAllModuleDataOfShopAll(1);
          this.getAllModuleDataOfShopAll(2);
          this.getAllModuleDataOfShopAll(4);
        }, 200);
      }
    })
  }

  async getGender() {
    const getGender = this.wsShopAllService.getGender()
    await lastValueFrom(getGender).then(async response => {
      if (response && response.statusCode == 200) {
        this.genderList = response.data;
      } else {
      }
    })
  }

  /**
  * Date:- 13-06-2023
  * Method :- This method is used to Get Address List
  * @param userId :-  This param is used for request to Get Address List
  */
  async getAddressList(userId: MAddressListRequest) {
    const addressList = this.wsUserProfileService.getAddressList(userId)
    await lastValueFrom(addressList).then(async response => {
      if (response && response.statusCode == 200) {
        this.mAddressListData = response.data
        this.defaultAddress = this.mAddressListData.filter((address: any) => address.is_default == true)[0];
      }
    })
  }

  /**
  * Date:- 13-06-2023
  * Method :- This method is used to Remove Address
  * @param addressId :-  This param is used for Remove Address
  */
  async removeAddress(addressId: any) {
    const removeAddress = this.wsUserProfileService.removeAddress(addressId)
    await lastValueFrom(removeAddress).then(async response => {
      if (response && response.statusCode == 200) {
        this.mAddressListReq.userId = this.id
        this.getAddressList(this.mAddressListReq)
      }
    })
  }

  /**
  * Date:- 14-06-2023
  * Method :- This method is used to Get Order Detail List
  * @param searchId :-  This param is used for request to Get Order Detail List
  */
  async getOrderDetaiList(search: MOrderDetailRequest) {
    const orderList = this.wsUserProfileService.getOrderDetailList(search)
    await lastValueFrom(orderList).then(async response => {
      if (response && response.statusCode == 200) {
        this.mOrderDetailListData = response.data
      }
    })
  }

  /**
  * Date:- 21-06-2023
  * Method :- This method is used to Get Order Detail List
  * @param userId :-  This param is used for request to Get Order Detail List
  */
  async getWishList(userId: string) {
    const wishList = this.wsUserProfileService.getWishList(userId)
    await lastValueFrom(wishList).then(async response => {
      if (response && response.statusCode == 200) {
        this.mWishlistData = response.data
      }
    })
  }

  /**
  * Date: 10-06-23
  * Method : This method is used to get all cart items 
  */
  async getAllCartProducts() {
    const getAllCart = this.wsShopAllService.getCartList("" + SharedPrefrences.getUserId())
    await lastValueFrom(getAllCart).then(async response => {
      if (response && response.statusCode == 200) {
        this.mAddUpdateCartModuleResponse.data = response.data;
      } else {
      }
    })
  }

  async addToCartCommon(product: any, type?: any, index?: any, productType?: any) {
    this.mAddUpdateCartModule.user_id = "" + SharedPrefrences.getUserId();
    if (type == 'cart') {
      this.mAddUpdateCartModule.iswishlistitem = false;
    } else {
      this.mAddUpdateCartModule.iswishlistitem = true;
    }
    this.mAddUpdateCartModule.product_id = product.id;
    if (type == "cart") {
      const cart = this.mAddUpdateCartModuleResponse.data && this.mAddUpdateCartModuleResponse.data.findIndex((cart: any) => { return cart.product_id === product.id })
      if (cart > -1) {
        this.mAddUpdateCartModule.qty = this.mAddUpdateCartModuleResponse.data[cart].qty + 1;
        this.mAddUpdateCartModule.id = this.mAddUpdateCartModuleResponse.data[cart].id;
      } else {
        this.mAddUpdateCartModule.qty = 1;
      }
      const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
      await lastValueFrom(addRemoveProductFromCart).then(async response => {
        if (response && response.statusCode == 200) {
          this._commonBehaviorChangeService.addCart(true);
        } else {
          console.log("something went wrong")
        }
      })
    } else {
      const wishlist = this.mWishlistData && this.mWishlistData.findIndex((wishlist: any) => { return wishlist.product_id === product.id })
      if (wishlist > -1) {
        this.mAddUpdateCartModule.id = this.mWishlistData[wishlist].id;
      }
      this.mAddUpdateCartModule.qty = 0;
      const addRemoveProductFromCart = this.wsShopAllService.addRemoveProductFromCart(this.mAddUpdateCartModule)
      await lastValueFrom(addRemoveProductFromCart).then(async response => {
        if (response && response.statusCode == 200) {
          this._commonBehaviorChangeService.addWishlist(true)
          if (productType == 'wishList') {
            this.mWishlistData.splice(index, 1)
          }
          this._commonBehaviorChangeService.addWishlist(true)
        } else {
          console.log("something went wrong")
        }
      })
    }
  }

  saveNewAddress(event: any) {
    if (event) {
      $('#add-new-address').hide();
      if(event.emailShow){
          $('#email-update-profile').show();
          $("#email-update-profile").attr("class", function(i:any, origValue:any){
            return origValue + " show";
         })
         this.profileData = {
          'first_name':event.first_name,
          'last_name': event.last_name,
          'id':this.id,
          'email':this.emailFormgroup.controls['email'].value
        }
         
            return;
          }else{
            this.mAddressListReq.userId = this.id
            this.getAddressList(this.mAddressListReq)
          }
    }
    this.viewForm = ''
    this.addressData = null;
    $('#add-new-address').hide();
    $(".modal-backdrop").hide();
  }


  showProduct(product: any) {
    var productName = product.name.split(' ').join('_').replace(',', '')
    this.router.navigate(["/product-detail-updated/" + product.id + '/' + productName.replace(/[&\/\#,+()$~%.'":*?<>{}]/g, '_')])
  }

  async getBase64ImageFromUrl(imageUrl: string, callback: any) {
    var res = await fetch(imageUrl);
    var blob = await res.blob();
    var reader = new FileReader();
    reader.onloadend = function () {
      callback(reader.result);
    }
    reader.readAsDataURL(blob);
  }
  toDataURL(url: string, callback: any) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      }
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  }
  getImageBase64(url: string) {
    this.getBase64ImageFromUrl(url, (result: string) => {
      return result;
    })
  }

  buyNowCommon(product: any) {
    const productDetail = {
      qty: 1,
      productId: product.id
    }
    localStorage.setItem("buynow", JSON.stringify(productDetail))
    const userAgent = window.navigator.userAgent.toLowerCase();
    var mobile = /iphone|ipad|ipod|android|blackberry|iemobile|opera mini/i.test(userAgent)
    if (mobile) {
      this.router.navigate(["/checkout-new-mob/buynow/" + product.id])
    } else {
      this.router.navigate(["/checkout-new/buynow/" + product.id])
    }
  }

  buyNow(product: any) {
    if (SharedPrefrences.getUserId() != null && SharedPrefrences.getUserId() != '') {
      this.buyNowCommon(product)
    } else {
      const modalRef = this.modalService.open(LoginPopupComponent);
      modalRef.componentInstance.type = 1;
      modalRef.componentInstance.emitService.subscribe((emmitedValue: any) => {
        if (emmitedValue) {
          this.buyNowCommon(product)
        }
      })
    }
  }

  selectProfileImage(event: any) {
    let userProfileImage = event.target.files[0]
    if (userProfileImage.size > 2048000) {
      this.toast.error('Maximum file size allowed is 2 MB. File larger than 2 MB will be discarded.');
    } else {
      if (userProfileImage) {
        var reader = new FileReader();
        reader.readAsDataURL(userProfileImage); // read file as data url
        reader.onload = (event: any) => { // called once readAsDataURL is completed
          var profilePic = event.currentTarget.result;
          this.userProfileForm.controls['profile_pic'].setValue(profilePic)
          this.profile_pic = profilePic;
        }
      }
    }
  }

  selectGender(id: any) {
    if(id == -1){
      return;
    }
    else{
      if(id == 0){
        this.selectedGenderLabel = 'Other';
      }
      else if(id == 1){
        this.selectedGenderLabel = 'Male';
      }
      else if(id == 2){
        this.selectedGenderLabel = 'Female';
      }
      this.selectedGender = id;
      this.userProfileForm.controls['gender'].setValue("" + this.selectedGender)
    }
  }

  /**
   * Date: 10-06-23
   * Method: This method is used to get subcategory , skintype and skin concern of selected category
   */
  async getAllModuleDataOfShopAll(catId: any) {
    const getAllModuleDataOfShopAll = this.wsShopAllService.getAllModuleDataOfShopAll("" + catId)
    await lastValueFrom(getAllModuleDataOfShopAll).then(async response => {
      if (response && response.statusCode == 200) {
        if (catId == 1) {
          this.skinDetailList = response.data;
        } else if (catId == 2) {
          this.makeupDetailList = response.data;
          if (!this.makeUpJson) {
            this.makeUpJson = {}
          }
          if (this.makeupDetailList && this.makeupDetailList.subCategoryList && this.makeupDetailList.subCategoryList.length > 0) {
            await this.makeupDetailList.subCategoryList.forEach(async (subCat: any, i: any) => {
              this.makeupDetailsAvailable = true;
              if (this.makeUpJson && Object.keys(this.makeUpJson).length > 0 && this.makeUpJson[subCat.name] && this.makeUpJson[subCat.name].length > 0) {
                this.makeUpJson[subCat.name].splice(this.makeUpJson[subCat.name].length - 1, 1)
              } else {
                this.makeUpJson[subCat.name] = [];
              }
              var selectedMakeUpData = [{
                key: 'Brand',
                value: ''
              },
              {
                key: 'Product',
                value: ''
              }
              ]

              this.makeUpJson[subCat.name].push(selectedMakeUpData)
            })
          }
        } else {
          this.hairDetailList = response.data;
        }
      } else {
      }
    })
  }

  async addMore(subCatName: any) {
    this.status = false;
    await this.makeUpJson[subCatName].forEach((ele: any, k: any) => {
      if (ele && ele[k] && !ele[k].value && ele[k].value == '' && ele[k].value == '') {
        this.toast.error("Please enter brand and product values")
        this.status = true;
      }
    })
    if (!this.status) {
      var selectedMakeUpData = [{
        key: 'Brand',
        value: ''
      },
      {
        key: 'Product',
        value: ''
      }
      ]
      this.makeUpJson[subCatName].push(selectedMakeUpData)
    }
    if (!this.status) {
      this.updateProfile()
    }
  }

  async updateMakeupDetail(subCatName: any) {
    this.status = false;
    await this.makeUpJson[subCatName].forEach((ele: any, k: any) => {
      if (ele && ele[k] && !ele[k].value && ele[k].value == '' && ele[k].value == '') {
        this.toast.error("Please enter brand and product values")
        this.status = true;
      }
    })
    if (!this.status) {
      this.updateProfile()
    }
  }

  async delete(subCatName: any, index: any) {
    if (this.makeupDetailList && this.makeupDetailList.subCategoryList && this.makeupDetailList.subCategoryList.length > 0) {
      await this.makeupDetailList.subCategoryList.forEach(async (subCat: any, i: any) => {
        if (subCatName == subCat.name) {
          this.makeUpJson[subCatName].splice(index, 1)
        }
      })
      this.updateProfile()
    }
  }

  async updateProfile() {
    this.isLoading = true;
    if(this.userProfileForm.invalid){
      this.isLoading = false;
      this.userProfileForm.markAllAsTouched();
      return;
    }
    let AllValues = JSON.parse(JSON.stringify(this.userProfileForm.value))
    if(AllValues.age == "" || AllValues.age == null){
      AllValues.age = 0
    }
    delete AllValues.alternet_phone_number;
    var profileData = AllValues;
    if (this.skinJson.skinType != 'null' && this.skinJson.skinType != null) {
      profileData['skin_type'] = JSON.stringify(this.skinJson.skinType)
    }

    if (this.skinJson.skinConcern.skinConcern1 != 'null' && this.skinJson.skinConcern.skinConcern1 != null) {
      profileData['skin_Concern1'] = JSON.stringify(this.skinJson.skinConcern.skinConcern1)
    }

    if (this.skinJson.skinConcern.skinConcern2 != 'null' && this.skinJson.skinConcern.skinConcern2
      != null) {
      profileData['skin_Concern2'] = JSON.stringify(this.skinJson.skinConcern.skinConcern2)
    }
    if (this.hairJson != 'null' && this.hairJson != null) {
      profileData['hair_json'] = JSON.stringify(this.hairJson)
    }
    if (Object.keys(this.makeUpJson).length > 0) {
      profileData['makeup_json'] = JSON.stringify(this.makeUpJson)
    }
    profileData['id'] = this.id;

    const updateProfile = this.wsUserProfileService.updateProfile(profileData)
    await lastValueFrom(updateProfile).then(async response => {
      if (response && response.statusCode == 200) {
        SharedPrefrences.setUserData(response.data)
        this._commonBehaviorChangeService.getToast("Profile Updated Successfully")
        this._commonBehaviorChangeService.updateProfileData(true);
        this.mUserProfileReq.id = this.id
        this.getUserPofile(this.mUserProfileReq)
        this.isLoading = false;
      } else {
        this.isLoading = false;
      }
    }, (error)=>{
      this._commonBehaviorChangeService.getToast("Something Went Wrong!!")
      this.mUserProfileReq.id = this.id
      this.getUserPofile(this.mUserProfileReq)
      this.isLoading = false;
    })

  }

  selectSkinType(val: any) {
    var skinType = [{
      id: val.split('_')[0],
      name: val.split('_')[1]
    }]
    this.skinJson.skinType = skinType
    this.updateProfile();
  }


  async selectSkinConcern(val: any) {
    var skinConcern = {
      id: val.split('_')[0],
      name: val.split('_')[1]
    }
    if (!this.skinJson.skinConcern.skinConcern1) {
      this.skinJson.skinConcern.skinConcern1.push(skinConcern)
    } else {
      var index = this.skinJson.skinConcern.skinConcern1 && this.skinJson.skinConcern.skinConcern1.findIndex((sc: any) => sc.id == skinConcern.id)
      if (index == -1) {
        this.skinJson.skinConcern.skinConcern1.push(skinConcern)
      } else {
        this.skinJson.skinConcern.skinConcern1.splice(index, 1)
      }
    }
    var sc = await this.skinJson.skinConcern.skinConcern1 && this.skinJson.skinConcern.skinConcern1.map((item: any) => {
      return item.id;
    });
    if (sc && sc.length > 0) {
      this.skinConcern1 = sc.join(',');
    }
    this.updateProfile();
  }

  selectHairType(val: any) {
    var hairType = [{
      id: val.split('_')[0],
      name: val.split('_')[1]
    }]
    this.hairJson.skinType = hairType
    this.updateProfile();
  }

  async selectHairConcern(val: any) {
    var hairConcern = {
      id: val.split('_')[0],
      name: val.split('_')[1]
    }
    if (this.hairJson.skinConcern.hairConcern1 && this.hairJson.skinConcern.hairConcern1.length < 1) {
      this.hairJson.skinConcern.hairConcern1.push(hairConcern)
    } else {
      var index = this.hairJson.skinConcern.hairConcern1.findIndex((hc: any) => hc.id == hairConcern.id)
      if (index == -1) {
        this.hairJson.skinConcern.hairConcern1.push(hairConcern)
      } else {
        this.hairJson.skinConcern.hairConcern1.splice(index, 1)
      }
    }

    var hc = await this.hairJson.skinConcern.hairConcern1 && this.hairJson.skinConcern.hairConcern1.map((item: any) => {
      return item.id;
    });
    if (hc && hc.length > 0) {
      this.hairConcern1 = hc.join(',');
    }
    this.updateProfile();
  }

  setMakeUp(event: any, index: any, subCatName: any) {
    this.makeUpJson[subCatName][index]['id'] = event.target.value.split('_')[0]
    this.makeUpJson[subCatName][index]['value'] = event.target.value.split('_')[0]
  }

  genderDropdown() {
    $('.gender-menu').toggleClass('dropdown-gender');
    $('.gender-select-new').slideToggle();
  }

  onSubmitEmail(){
    if(this.emailFormgroup.invalid){
      this.emailFormgroup.markAllAsTouched();
      return;
    }
    this.profileData.email = this.emailFormgroup.controls['email'].value;
    this.updateProfile1(this.profileData)
  }

  async updateProfile1(profileData:any){
    const updateProfile = this.wsUserProfileService.updateProfile(profileData)
    await lastValueFrom(updateProfile).then(async response => {
      if (response && response.statusCode == 200) {
        SharedPrefrences.setUserData(response.data)
        this._commonBehaviorChangeService.updateProfileData(true)
        window.location.reload();
      } else {

      }
    })

  }

  closeModal(){
    $('#email-update-profile').hide();
    this.emailFormgroup.reset();
  }
  
}
